var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#E49CAA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 23C15.75 22.4477 16.1977 22 16.75 22H18.25C18.8023 22 19.25 22.4477 19.25 23V29H15.75V23Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 19.5C21 18.9477 21.4477 18.5 22 18.5H23.5C24.0523 18.5 24.5 18.9477 24.5 19.5V29H21V19.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 16C26.25 15.4477 26.6977 15 27.25 15H28.75C29.3023 15 29.75 15.4477 29.75 16V29H26.25V16Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7701 12.3524C16.733 12.4592 16.6324 12.5307 16.5194 12.5307H15.0672C15.5214 12.8693 15.7815 13.3388 15.8475 13.9392H16.5194C16.702 13.9392 16.83 14.1192 16.7701 14.2916C16.733 14.3983 16.6324 14.4699 16.5194 14.4699H15.8535C15.8013 15.0661 15.5535 15.5334 15.1102 15.872C14.6669 16.2106 14.068 16.3785 13.3135 16.3759L16.0324 19.3348C16.0477 19.3515 16.0515 19.3757 16.0419 19.3962C16.0327 19.416 16.013 19.4286 15.9912 19.4286H15.5767C15.3793 19.4286 15.1909 19.3459 15.0573 19.2006L12.4539 16.3704C12.4065 16.3188 12.3776 16.2528 12.3718 16.1829C12.3568 15.9993 12.5017 15.842 12.6858 15.842H13.2833C13.8036 15.8378 14.2308 15.714 14.565 15.4706C14.9025 15.2231 15.1193 14.8633 15.1679 14.4699H12.2656C12.0831 14.4699 11.955 14.2899 12.0149 14.1175C12.052 14.0107 12.1526 13.9392 12.2656 13.9392H15.161C15.1141 13.5463 14.9022 13.1855 14.5702 12.9329C14.2394 12.6821 13.7844 12.5481 13.205 12.5307H12.3483C12.1648 12.5307 12.0367 12.3489 12.0984 12.1761C12.1361 12.0705 12.2361 12 12.3483 12H16.5194C16.702 12 16.83 12.18 16.7701 12.3524Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.55,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashIcon1);
export default __webpack_public_path__ + "static/media/dash-icon-1.2078e5ad50c39f77e38eae3e5b6e08f0.svg";
export { ForwardRef as ReactComponent };